import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import {
  Button,
  Textarea,
  Input,
  FormElement,
  FormSection,
  FormButton
} from "../../../Common/UI/Index";
import { ButtonVariantType, InputType } from "../../../Common/UI/Types";
import { CreateVersionFormFields } from "./redux/Types";

interface CreateVersionFormViewProps {
  /**
   * Handler for closing the dialog
   */
  onCancel: () => void;
  /**
   * Handler for creating new version
   */
  onCreate: () => void;
  /**
   * Handler for on change
   */
  onChange: (event: React.SyntheticEvent) => void;
  /**
   * Form field details
   */
  formFields: CreateVersionFormFields;
}

/**
 * Responsible for rendering the create new version form
 */
export const CreateVersionFormView: React.FC<CreateVersionFormViewProps> =
  (props: CreateVersionFormViewProps): JSX.Element => {

    const { t: translate } = useTranslation();
    const { onCancel, onCreate, onChange, formFields } = props;
    const isValidName = formFields?.name?.isValid;
    const enableCreateButton = formFields?.name?.value !== "";
    const errorText = formFields?.name?.errorText;

    return (
      <div
        className="ebt-extract__new-version"
        data-testid="ebt-extract__new-version"
      >
        <FormSection>
          <FormElement
            fieldId="titleField"
            labelText={translate("Extract.ExtractAdd.Title")}
            mandatory={true}
            errorText={errorText}
          >
            <Input
              className="ebt-extract__new-version_title"
              type={InputType.Text}
              name="name"
              data-testid="version-title"
              required={true}
              onChange={onChange}
              invalid={!isValidName}
            />
          </FormElement>
          <FormElement
            fieldId="descriptionField"
            labelText={translate("Extract.ExtractAdd.Description")}
          >
            <Textarea
              className="ebt-extract__new-version__description"
              data-testid="version-description"
              name="description"
              rows={13}
              required={true}
              onChange={onChange}
            />
          </FormElement>
          <FormButton className="ebt-extract__new-version__action-buttons">
            <Button
              borderless={true}
              data-testid="new-version-cancel"
              onClick={onCancel}
            >
              {translate("Button.Cancel")}
            </Button>
            <Button
              className="ebt-extract__new-version__action-buttons--create"
              variant={ButtonVariantType.FILLED}
              data-testid="new-version-create"
              onClick={onCreate}
              disabled={!enableCreateButton || !isValidName}
            >
              {translate("Button.Create")}
            </Button>
          </FormButton>
        </FormSection>
      </div>
    );
  };
